<template>
  <div class="user-tab-container">
    <div class="user-tab column" :class="showMenu ? 'close' : ''">
      <div
        class="info row align-center justify-space"
        @click="showMenu = !showMenu"
      >
        <i class="fa fa-bars font-25"></i>

        <!-- <div class="avatar row">
          <img
            v-if="user.link_foto_doutor && user.perfil == 'doutor'"
            :src="user.link_foto_doutor"
          />
          <img src="../assets/img/usuario_padrao.png" v-else />
        </div> -->
        <div class="name column grid">
          <strong>{{ user.nome || "Nome do usuário" }}</strong>
          <br />
          {{ user.email }}
        </div>

        <i class="arrow-down fa fa-chevron-down"></i>
      </div>
      <ul class="user-tab-menu column">
        <router-link v-if="perfil" :to="perfil">
          <li
            @click="
              showMenu = false;
              clearMenu();
            "
          >
            <i class="fa fa-user"></i> Meus Dados
          </li>
        </router-link>
        <router-link v-if="account" :to="account">
          <li
            @click="
              showMenu = false;
              clearMenu();
            "
          >
            <i class="fa fa-cog"></i> Conta
          </li>
        </router-link>
        <li @click="SET_LOGOUT(exit)"><i class="fa fa-sign-out"></i> Sair</li>

        <li
          class="font-20 column justify-center align-end"
          @click="showMenu = !showMenu"
        >
          <i class="fa fa-angle-up" style="margin-top: -7px"></i>
        </li>
      </ul>
    </div>
    <div class="mask" @click="showMenu = false" v-if="showMenu"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "UserTab",
  props: {
    perfil: {
      type: String,
    },
    account: {
      type: String,
    },
    exit: {
      type: String,
    },
  },
  components: {},
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    ...mapActions("user", ["SET_LOGOUT"]),
    clearMenu() {
      this.$parent.$parent.$children[0].changeMenu("");
    },
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
.user-tab-container {
  width: 100%;
  .mask {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 90;
  }
}
.user-tab {
  height: 74px;
  font-size: 12px;
  overflow: hidden;
  border-radius: 10px;
  z-index: 99;

  .avatar {
    width: 30px;
    height: 30px;
  }

  .info {
    margin-top: 22px;
    margin-left: 15px;
    cursor: pointer;
    .arrow-down {
      margin-right: 15px;
    }
  }
  .name {
    margin-left: 10px;
    font-size: 11px;
    @media (max-width: $medium) {
      font-size: 12px;
    }
    @media (max-width: $medium) {
      display: none;
    }
  }

  &-menu {
    list-style: none;
    margin-top: 35px;
    z-index: 991;
    @media (max-width: $small) {
      border-radius: 10px;
    }
    li {
      padding: 12px;
      cursor: pointer;
      i {
        margin-right: 5px;
      }
    }
    li:hover {
      background: $gray-3;

      &:nth-of-type(3):hover {
        background: $gray-2;
      }
    }
  }
  &.close {
    @media (min-width: $medium) {
      height: 165px;
      margin-top: -92px;
    }
    @media (max-width: $medium) {
      left: 2%;
      top: 15px;
      /* top: 80px; */
      width: 95%;
      height: 165px;
      position: absolute;
      .name {
        display: block;
      }
      .arrow-down {
        display: none;
      }
    }
  }
}
</style>